import React from 'react';
import { SkeletonComponent } from '@design-system';

export const MesCongesSkeleton: React.FC = () => {
    return (
        <div>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '109px',
                        width: '100%',
                        margin: '-2px auto',
                        borderRadius: '12px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
